import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '@services/user';

@Component({
  selector: 'app-premium-service-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './premium-service-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumServiceCardComponent {
  @Input() added = false;
  @Input() compact = false;
  @Input() mainBanner = false;
  @Input() moneyBackVisible = false;
  @Input() showAction = true;
  @Output() action = new EventEmitter<void>();

  constructor(readonly userService: UserService) {}

  handleAction(): void {
    this.action.emit();
  }
}
